import type { Dayjs } from 'dayjs';
import type { RegisterOriginalsPreparedBody } from '../types';
import { trimOptionalComment } from './commentPolicy';
import { validateTaskModalEventDate } from './taskModalValidation';

export type PrepareOriginalsValidationCode = 'EVENT_DATE_REQUIRED';

export type PrepareOriginalsValidationIssue = {
  code: PrepareOriginalsValidationCode;
  message: string;
};

export type ValidatePrepareOriginalsFormInput = {
  eventAt: Dayjs | null | undefined;
  comment: string | null | undefined;
};

export function validatePrepareOriginalsSubmit(
  input: ValidatePrepareOriginalsFormInput
): PrepareOriginalsValidationIssue | null {
  return validateTaskModalEventDate(
    input.eventAt,
    'Укажите дату подготовки'
  ) as PrepareOriginalsValidationIssue | null;
}

export function buildPrepareOriginalsBody(input: {
  comment: string | null | undefined;
  preparedAt: string;
}): RegisterOriginalsPreparedBody {
  const body: RegisterOriginalsPreparedBody = {
    preparedAt: input.preparedAt,
  };
  const trimmedComment = trimOptionalComment(input.comment);
  if (trimmedComment) {
    body.comment = trimmedComment;
  }
  return body;
}
